"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeatureSwitches = void 0;
const object_hash_1 = __importDefault(require("object-hash"));
const createFeatureSwitches = (featureDefaultsByEnvironment, environmentCheckers, config = { localStorageKey: "features" }) => {
    let featureDefaults;
    if (environmentCheckers.isDev()) {
        featureDefaults = featureDefaultsByEnvironment.dev;
    }
    else if (environmentCheckers.isStaging()) {
        featureDefaults = featureDefaultsByEnvironment.staging;
    }
    else if (environmentCheckers.isProduction()) {
        featureDefaults = featureDefaultsByEnvironment.production;
    }
    else {
        throw new Error("Environment cannot be identified");
    }
    featureDefaults = Object.fromEntries(Object.keys(featureDefaults)
        .filter((key) => typeof featureDefaults[key] === "boolean")
        .map((key) => [key, featureDefaults[key]]));
    const loadFeatureSwitches = () => {
        if (environmentCheckers.isProduction()) {
            return;
        }
        const newHash = object_hash_1.default(featureDefaults, {
            algorithm: "md5",
            encoding: "base64",
            respectFunctionProperties: false,
            respectType: false,
        });
        const oldHash = localStorage.getItem(`${config.localStorageKey}_hash`) || "";
        if (oldHash !== newHash) {
            localStorage.setItem(config.localStorageKey, JSON.stringify(featureDefaults));
            localStorage.setItem(`${config.localStorageKey}_hash`, newHash);
        }
    };
    const featureSwitches = Object.entries(featureDefaults).reduce((features, [featureName, featureValue]) => ({
        ...features,
        [featureName]: () => {
            if (environmentCheckers.isProduction()) {
                return featureValue;
            }
            let featuresInLocalStorage;
            try {
                featuresInLocalStorage = JSON.parse(localStorage.getItem(config.localStorageKey) || "{}");
            }
            catch (error) {
                featuresInLocalStorage = {};
            }
            return typeof featuresInLocalStorage[featureName] !== "undefined"
                ? featuresInLocalStorage[featureName]
                : featureValue;
        },
    }), {});
    const updateFeatureSwitchValue = (key, value, reload = true) => {
        if (environmentCheckers.isProduction()) {
            return;
        }
        const featuresInLocalStorage = JSON.parse(localStorage.getItem(config.localStorageKey) || "{}");
        featuresInLocalStorage[key] = value;
        localStorage.setItem(config.localStorageKey, JSON.stringify(featuresInLocalStorage));
        if (reload)
            location.reload();
    };
    const updateAllFeatureSwitches = (featureSwitches, reload = true) => {
        if (environmentCheckers.isProduction()) {
            return;
        }
        localStorage.setItem(config.localStorageKey, JSON.stringify(featureSwitches));
        if (reload)
            location.reload();
    };
    return {
        featureSwitches,
        updateFeatureSwitchValue,
        loadFeatureSwitches,
        updateAllFeatureSwitches,
    };
};
exports.createFeatureSwitches = createFeatureSwitches;
